<template>
  <div>
    <PageTable :shipmentCode="shipmentCode" :disabled="disabled" />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
